import { createApp } from 'vue';
import App from './App.vue';
import router from "./router";
import AOS from 'aos';
import 'aos/dist/aos.css';
import i18n from './i18n';
import store from "./state/store";

import BootstrapVue3 from 'bootstrap-vue-3';
import vClickOutside from "click-outside-vue3";
import VueApexCharts from "vue3-apexcharts";
import { vMaska } from 'maska';

import VueFeather from 'vue-feather';
import Particles from "particles.vue3";

import '@/assets/scss/config/default/app.scss';
import '@vueform/slider/themes/default.css';
import '@/assets/scss/mermaid.min.css';

AOS.init({
    easing: 'ease-out-cubic',
    duration: 200,
    once: true,
});

const app = createApp(App);

// Permission helpers available in every component.
//
// These are exposed as globalProperties (NOT just provide/inject): in Vue 3 a
// template identifier that starts with "$" — like `$hasPermission(...)` used in
// menu.vue's v-if — is resolved from app.config.globalProperties, never from
// inject. Relying on inject alone left `$hasPermission` undefined in templates,
// which threw and blanked the whole sidebar. We keep provide() too so any
// component using `inject: ['$hasPermission']` in <script> still resolves.
const hasPermission = (permission) => store.getters['authfack/hasPermission'](permission);
const hasRole = (role) => store.getters['authfack/hasRole'](role);

app.config.globalProperties.$hasPermission = hasPermission;
app.config.globalProperties.$hasRole = hasRole;

app.provide('$hasPermission', hasPermission);
app.provide('$hasRole', hasRole);

app
    .use(store)
    .use(router)
    .use(VueApexCharts)
    .use(BootstrapVue3)
    .component(VueFeather.type, VueFeather)
    .directive('maska', vMaska)
    .use(Particles)
    .use(i18n)
    .use(vClickOutside)
    .mount('#app');

// Progressive Web App: register the service worker + install prompt handling.
import { initPwa } from './pwa';
initPwa();

// Optional offline "work locally, sync later" feature (enabled per install).
import { initOffline } from './helpers/offline';
initOffline();
